<app-header></app-header>
<app-side-nav></app-side-nav>

<div class="bg" [ngStyle]="{opacity: vip.store.isLoadingPage ? '0' : '1'}">
  <div class="container flex justify-center items-center flex-col pt-70 sm:pt-20">
    <div class="text-26 font-weight-700 sm:text-18">{{ 't.vip-program' | translate }}</div>
    @if (!user.auth) {
      <img class="w-25 my-40 md:w-50 sm:w-75 sm:my-20" src="/assets/img/vip/panda.png" alt="">
      @if (vip?.store.page?.SeoTitle) {
        <h1 class="text-24 font-weight-700 uppercase">{{ vip?.store.page?.SeoTitle }}</h1>
      } @else {
        <div class="text-24 font-weight-700 uppercase">{{ vip?.store.page?.NoAuthTitle }}</div>
      }
      <div class="text-14 font-weight-400 mt-20">{{ vip?.store.page?.NoAuthDesc }}</div>
      <div class="mt-40">
        <button (click)="user.authUser()" class="btn btn--filled-primary">
          {{ user.authKeyTranslate | translate }}
        </button>
      </div>
    }
    @if (user.auth && !vip.store.currentVipUserLevel) {
      <img class="w-25 my-40 md:w-50 sm:w-75 sm:my-20" src="/assets/img/vip/panda.png" alt="">
      <div class="text-42 font-weight-700 sm:text-24">{{ 't.become-vip' | translate }}</div>
    }
    @if (user.auth && vip.store.currentVipUserLevel) {
      <img class="w-25 my-40 md:w-50 sm:w-75 sm:my-20" [src]="vip?.store.currentVipUserLevel?.Image" alt="">
      <app-vip-level-label
        [levelName]="vip.store.currentVipUserLevel?.LevelName">
      </app-vip-level-label>
    }
    @if (user.auth) {
      <app-vip-progress-bar></app-vip-progress-bar>
    }
  </div>
  @if (vip.store.currentVipUserLevel) {
    <div class="container my-60 md:hidden">
      <div class="flex gap-24">
        <div class="relative flex-1">
          <div class="text-14 font-weight-700 uppercase">{{ 't.personal-managers' | translate }}</div>
          <div class="text-12 font-weight-600 mb-20 mt-6 support">{{ 't.support-vip' | translate }}</div>
          <div class="flex gap-12 relative z-9 items-center managers-header">
            <img class="avatar sm:pl-10 pt-10" src="/assets/img/vip/avatar.png" alt="">
            <div class="pt-10">
              <div class="flex">
                @if (vip.store.page?.CurrentManager) {
                  <div class="text-10 font-weight-600 mr-14">
                    {{ vip.store.page?.CurrentManager?.name }}
                  </div>
                  <div class="flex gap-12 mb-6">
                    <img class="social-img" src="/assets/img/vip/socials/telegram.svg" alt="">
                    <img class="social-img" src="/assets/img/vip/socials/whatsapp.svg" alt="">
                    <img class="social-img" src="/assets/img/vip/socials/email.svg" alt="">
                  </div>
                } @else {
                  <div class="text-10 font-weight-600">
                    {{ 't.manager-assign-soon' | translate }}
                  </div>
                }
              </div>
              @if (vip.store.page?.CurrentManager) {
                <div class="text-10 font-weight-600">{{ 't.can-be-manager' | translate }}</div>
              }
            </div>
            @if (vip.store.page?.CurrentManager) {
              <i (click)="vip.toggleManagers()" class="icon-arrow-down"></i>
            }

            @if (vip.store.isShowManagers) {
              @if (vip.store.page?.CurrentManager) {
                <div class="managers-content flex flex-col pt-60 social-section">
                  @if (vip.store.page?.CurrentManager?.telegramLink) {
                    <div class="flex items-center social-item">
                      <img class="social-img" src="/assets/img/vip/socials/telegram.svg" alt="">
                      <a class="text-12 font-weight-700" [href]="vip.store.page?.CurrentManager?.telegramLink"
                         target="_blank">{{ '@' + vip.store.page?.CurrentManager?.telegramName }}</a>
                      <div class="cursor-pointer" (click)="copy.copy('', vip.store.page?.CurrentManager?.telegramLink)">
                        <i class="icon-copy text-12"></i>
                      </div>
                    </div>
                  }
                  @if (vip.store.page?.CurrentManager?.whatsAppLink) {
                    <div class="flex gap-10 items-center social-item">
                      <img class="social-img" src="/assets/img/vip/socials/whatsapp.svg" alt="">
                      <a class="text-12 font-weight-700" [href]="vip.store.page?.CurrentManager?.whatsAppLink"
                         target="_blank">{{ '@' + vip.store.page?.CurrentManager?.whatsAppName }}</a>
                      <div class="cursor-pointer" (click)="copy.copy('', vip.store.page?.CurrentManager?.whatsAppLink)">
                        <i class="icon-copy text-12"></i>
                      </div>
                    </div>
                  }
                  @if (vip.store.page?.CurrentManager?.email) {
                    <div class="flex gap-10 items-center social-item">
                      <img class="social-img" src="/assets/img/vip/socials/email.svg" alt="">
                      <a class="text-12 font-weight-700" [href]="'mailto:' + vip.store.page?.CurrentManager?.email"
                         target="_blank">{{ vip.store.page?.CurrentManager?.email }}</a>
                      <div class="cursor-pointer" (click)="copy.copy('', vip.store.page?.CurrentManager?.email)">
                        <i class="icon-copy text-12"></i>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
        <div class="grid grid-cols-2 gap-28 flex-1">
          @for (benefit of vip.store.page?.Benefits; track $index) {
            <div class="text-14 font-weight-700 uppercase">{{ benefit?.title }}</div>
          }
        </div>
      </div>
    </div>
    <div class="ticker-tape-container hidden md:flex w-100">
      @for (i of [1, 2]; track $index) {
        <div class="ticker-tape flex gap-12">
          <div class="box ticker-tape__item">
            @for (benefit of vip.store.page?.Benefits | slice: 0 : 2; track $index) {
              <div>{{ benefit?.title }}</div>
            }
          </div>
          <div class="flex flex-col gap-12">
            @for (benefit of vip.store.page?.Benefits | slice: 2 : 4; track $index) {
              <div class="box ticker-tape__item">
                {{ benefit?.title }}
              </div>
            }
          </div>
          <div class="box ticker-tape__item">
            @for (benefit of vip.store.page?.Benefits | slice: 0 : 2; track $index) {
              <div>{{ benefit?.title }}</div>
            }
          </div>
          <div class="flex flex-col gap-12">
            @for (benefit of vip.store.page?.Benefits | slice: 2 : 4; track $index) {
              <div class="box ticker-tape__item">
                {{ benefit?.title }}
              </div>
            }
          </div>
          <div class="md:hidden">
            {{ 't.manager-assign-soon' | translate }}
          </div>
        </div>
      }
    </div>
    <div class="container hidden md:block">
      <div class="accordion">
        <div Accordion class="accordion__header mt-20">
          <div class="flex gap-12 relative z-9 items-center managers-content__header">
            <img class="avatar pl-10 pt-10" src="/assets/img/vip/avatar.png" alt="">
            <div class="pt-10">
              @if (vip.store.page?.CurrentManager) {
                <div class="flex">
                  <div class="text-10 font-weight-600 mr-14">
                    {{ vip.store.page?.CurrentManager.name }}
                  </div>
                  <div class="flex gap-12 mb-6">
                    <img class="social-img" src="/assets/img/vip/socials/telegram.svg" alt="">
                    <img class="social-img" src="/assets/img/vip/socials/whatsapp.svg" alt="">
                    <img class="social-img" src="/assets/img/vip/socials/email.svg" alt="">
                  </div>
                </div>
                <div class="text-10 font-weight-600">{{ 't.can-be-manager' | translate }}</div>
              } @else {
                <div class="text-10 font-weight-600">
                  {{ 't.manager-assign-soon' | translate }}
                </div>
              }
            </div>
            @if (vip.store.page.CurrentManager) {
              <i class="icon-arrow-down text-10"></i>
            }
          </div>
        </div>
        @if (vip.store.page.CurrentManager) {
          <div class="accordion__content">
            <div class="flex flex-col pt-60 social-section">
              @if (vip.store.page?.CurrentManager?.telegramLink) {
                <div class="flex items-center social-item">
                  <img class="social-img" src="/assets/img/vip/socials/telegram.svg" alt="">
                  <a class="text-12 font-weight-700" [href]="vip.store.page?.CurrentManager?.telegramLink"
                     target="_blank">{{ '@' + vip.store.page?.CurrentManager?.telegramName }}</a>
                  <div class="cursor-pointer" (click)="copy.copy('', vip.store.page?.CurrentManager?.telegramLink)">
                    <i class="icon-copy text-12"></i>
                  </div>
                </div>
              }
              @if (vip.store.page?.CurrentManager?.whatsAppLink) {
                <div class="flex gap-10 items-center social-item">
                  <img class="social-img" src="/assets/img/vip/socials/whatsapp.svg" alt="">
                  <a class="text-12 font-weight-700" [href]="vip.store.page?.CurrentManager?.whatsAppLink"
                     target="_blank">{{ '@' + vip.store.page?.CurrentManager?.whatsAppName }}</a>
                  <div class="cursor-pointer" (click)="copy.copy('', vip.store.page?.CurrentManager?.whatsAppLink)">
                    <i class="icon-copy text-12"></i>
                  </div>
                </div>
              }
              @if (vip.store.page?.CurrentManager?.email) {
                <div class="flex gap-10 items-center social-item">
                  <img class="social-img" src="/assets/img/vip/socials/email.svg" alt="">
                  <a class="text-12 font-weight-700" [href]="'mailto:' + vip.store.page?.CurrentManager?.email"
                     target="_blank">{{ vip.store.page?.CurrentManager?.email }}</a>
                  <div class="cursor-pointer" (click)="copy.copy('', vip.store.page?.CurrentManager?.email)">
                    <i class="icon-copy text-12"></i>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (user.auth) {
    @if (!vip.store.currentVipUserLevel) {
      <ng-container *ngTemplateOutlet="howGetVip"></ng-container>
    }
    @if (vip.store.nextVipUserLevel) {
      <div class="container text-center my-60">
        <div class="text-26 mb-40 uppercase font-weight-700 sm:text-24">{{ vip?.store.page?.HowEarnPointsTitle }}</div>
        <div>
          <app-vip-level-label [levelName]="vip.store.nextVipUserLevel?.LevelName"></app-vip-level-label>
        </div>
        <div #rules class="mt-40 grid grid-cols-3 gap-24 md:grid-cols-1 earn">
          @for (rule of vip.store.nextVipUserLevel?.HowEarnVPoints | slice: 0: isMobile() ?
            vip.store.visibleRulesCount : vip.store.nextVipUserLevel?.HowEarnVPoints.length; track $index) {
            <div class="box earn__item">
              <div class="text-left pb-10 text-14">{{ rule?.title }}</div>
              <div class="flex gap-24">
                <div class="flex gap-6">
                  <div class="text-left text-14"
                       [ngStyle]="{opacity: rule?.firstCondition ? '0.2' : ''}"
                       [innerHTML]="rule?.firstDesc"></div>
                  @if (rule.firstCondition) {
                    <i class="icon-apply"></i>
                  }
                </div>
                @if (rule?.secondDesc) {
                  <div class="spacer"></div>
                }
                <div class="flex gap-6">
                  <div class="text-left text-14"
                       [ngStyle]="{opacity: rule?.secondCondition || rule?.thirdCondition ? '0.2' : ''}"
                       [innerHTML]="rule?.secondDesc"></div>
                  @if (rule.secondDesc && (rule.secondCondition || rule.thirdCondition)) {
                    <i class="icon-apply"></i>
                  }
                </div>
              </div>
            </div>
          }
          @if (vip.store.nextVipUserLevel?.HowEarnVPoints?.length > vip.store.visibleRulesCount && isMobile()) {
            <div (click)="showMore(vip.store.nextVipUserLevel?.HowEarnVPoints?.length)"
                 class="text-14 font-weight-700 more">{{ 't.more' | translate }}
            </div>
          }
        </div>
      </div>
    }
    @if (vip.bonuses$.bonuses$ | async; as listTypes) {
      <div class="container">
        @if (listTypes[BonusStage.VIP].length) {
          <div class="font-weight-800 text-26 mb-40 uppercase text-center">
            {{ 't.vip-bonuses' | translate }}
          </div>
          <div class="grid grid-cols-3 md:grid-cols-1">
            @for (bonus of listTypes[BonusStage.VIP]; track $index) {
              <app-bonus-preview [bonus]="bonus"></app-bonus-preview>
            }
          </div>
        }
      </div>
    }
    @if (vip.lastPlayed$ | async; as gameList) {
      @if (gameList.length) {
        <div class="container my-60">
          <div class="font-weight-800 text-26 mb-40 uppercase text-center">
            {{ vip.store.page?.VipGamesTitle }}
          </div>
          <div class="game-grid game-grid--5">
            @for (game of gameList; track $index) {
              <div class="game-grid__item">
                <app-game-preview [game]="game"></app-game-preview>
              </div>
            }
          </div>
          @if (gameList?.length >= 5) {
            <div routerLink="/games/last-played" class="flex items-center justify-center mt-24">
              <button class="btn btn--filled-primary">
                {{ 't.more' | translate }}
              </button>
            </div>
          }
        </div>
      }
    }
    @if (vip.tournaments$ | async; as tournaments) {
      @if (tournaments.length) {
        <div class="container my-60">
          <div class="font-weight-800 text-26 mb-40 uppercase text-center">
            {{ vip.store.page?.VipTournamentsTitle }}
          </div>
          <div class="block md:hidden">
            @for (tournament of tournaments; track $index) {
              <app-tournament-preview
                [tournament]="tournament">
              </app-tournament-preview>
            }
          </div>
          <div class="hidden md:block">
            <app-slider
              #tournamentsSlider
              [slideList]="tournaments"
              [config]="vip.vipTournamentsSliderConfig"
              [intersectionObserver]="false">
              @for (tournament of tournaments; track $index) {
                <app-tournament-preview
                  [tournament]="tournament">
                </app-tournament-preview>
              }
            </app-slider>
            @if (tournamentsSlider) {
              <div class="pagination flex items-center justify-center relative">
            <span class="pagination__action--btn left flex items-center justify-center text-10"
                  (click)="tournamentsSlider?.slider?.prev()"><i class="icon-arrow"></i></span>
                <ng-container *ngTemplateOutlet="tournamentsSlider?.paginationElement()"></ng-container>
                <span class="pagination__action--btn right flex items-center justify-center text-10"
                      (click)="tournamentsSlider?.slider?.next()"><i class="icon-arrow"></i></span>
              </div>
            }
          </div>
        </div>
      }
    }
  }
  @if (!vip.store.currentVipUserLevel) {
    <div class="container text-center my-60">
      <div class="text-26 font-weight-700 sm:text-24">{{ vip?.store.page?.VipBenefitsTitle }}</div>
      <div class="my-40 grid grid-cols-4 sm:grid-cols-1 benefits">
        @for (item of vip.store.page?.Benefits; track $index) {
          <div class="flex flex-col items-center benefits__item">
            <img class="w-25" [src]="'/assets/img/vip/benefits/' + $index + '.png'" alt="">
            <div class="mt-20 text-14 font-weight-400">{{ item?.title }}</div>
          </div>
        }
      </div>
      @if (!user.auth) {
        <div>
          <button (click)="user.authUser()" class="btn btn--filled-primary">
            {{ user.authKeyTranslate | translate }}
          </button>
        </div>
      }
    </div>
  }
  @if (!user.auth) {
    <ng-container *ngTemplateOutlet="howGetVip"></ng-container>
  }
  <div class="container my-60 text-center">
    <div class="text-26 font-weight-700">{{ vip?.store.page?.VipLevelsTitle }}</div>
    <div class="text-14 font-weight-400 my-40">{{ vip?.store.page?.VipLevelsDesc }}</div>
    @if (vip.store.vipLevels?.length) {
      <div class="levels__slider">
        <app-slider
          #levelsSlider
          [slideList]="vip.store?.vipLevels"
          [config]="vip.vipLevelsSliderConfig"
          [intersectionObserver]="false">
          @for (level of vip.store?.vipLevels; track $index) {
            <div class="box levels__slider-item">
              <div class="flex justify-between items-center mr-40 ml-40 mb-20">
                <div>
                  <div class="text-24 text-left font-weight-700">
                    {{ level.LevelName }}
                  </div>
                  <div class="flex text-left mt-4">
                    <div class="text-12 v-points">{{ 't.points' | translate }}: &nbsp;</div>
                    <div class="text-12">{{ level.VPointsToReach }}</div>
                  </div>
                </div>
                <img class="w-50" [src]="level.Image" alt="">
              </div>
              @for (benefit of level.Benefits; track $index) {
                <div class="flex gap-12 justify-between items-center mr-40 ml-40 relative levels__slider-section">
                  <div [style.color]="benefit.active ? '#FFFFFF' : '#7E77AC'"
                       class="text-12 my-10 text-left">
                    {{ benefit.title }}
                  </div>
                  @if (benefit.active) {
                    <i class="icon-apply text-24"></i>
                  }
                </div>
              }
            </div>
          }
        </app-slider>
        @if (levelsSlider) {
          <div class="pagination flex items-center justify-center relative mt-40">
            <span class="pagination__action--btn left flex items-center justify-center text-10"
                  (click)="levelsSlider?.slider?.prev()"><i class="icon-arrow"></i></span>
            <ng-container *ngTemplateOutlet="levelsSlider?.paginationElement()"></ng-container>
            <span class="pagination__action--btn right flex items-center justify-center text-10"
                  (click)="levelsSlider?.slider?.next()"><i class="icon-arrow"></i></span>
          </div>
        }
      </div>
    }
  </div>
  @if (!user.auth) {
    <div class="container text-center my-60">
      <div class="text-26 font-weight-700 uppercase">{{ vip?.store.page?.VipAdvantagesTitle }}</div>
      <div class="features my-40 grid grid-cols-2 md:flex flex-col-reverse">
        <div class="flex gap-24 items-center md:flex-col">
          <img class="flex-1 w-25 md:w-50" src="/assets/img/vip/advantages.png" alt="">
          <div class="flex-1 text-14 text-left md:text-center">{{ vip?.store.page?.VipAdvantagesDesc }}</div>
        </div>
        <div class="grid grid-cols-2 md:gap-12">
          @for (item of vip?.store.page?.VipAdvantagesFeatures; track $index) {
            <div class="flex gap-12 items-center md:flex-col items-center">
              <img class="w-25" [src]="'/assets/img/vip/advantages/' + $index + '.png'" alt="">
              <div class="text-14 text-left md:text-center">{{ item?.desc }}</div>
            </div>
          }
        </div>
      </div>
      <div>
        <button (click)="user.authUser()" class="btn btn--filled-primary">
          {{ user.authKeyTranslate | translate }}
        </button>
      </div>
    </div>
  }

  <div class="container my-60">
    <div class="text-26 font-weight-700 uppercase text-center mb-40">FAQ</div>
    <app-terms [accordionTitle]="'t.faq'" [content]="vip.store.page?.Faq"></app-terms>
  </div>

  <app-bottom-navigation></app-bottom-navigation>
  <app-footer></app-footer>
</div>

<ng-template #howGetVip>
  <div class="container my-60 text-center">
    <div class="text-26 font-weight-700">{{ vip?.store.page?.HowGetVipTitle }}</div>
    <div class="grid grid-cols-3 became-vip my-40 md:grid-cols-1">
      @for (item of vip.store.page?.HowGetVip; track $index) {
        <div class="box became-vip__item">
          <div class="sm:flex flex-row-reverse gap-12">
            <div>
              <img class="w-50" [src]="'/assets/img/vip/became/' + $index + '.png'" alt="">
            </div>
            <div class="sm:text-left">
              <div>
                <div class="text-34 font-weight-700 my-20 uppercase sm:text-18 sm:my-8">{{ item?.title }}</div>
                <div class="text-14 font-weight-400">{{ item?.desc }}</div>
              </div>
              @if (user.auth) {
                <div class="mt-20 block md:hidden">
                  <button routerLink="/deposit" class="btn btn--filled-primary">
                    {{ 't.deposit' | translate }}
                  </button>
                </div>
              }
            </div>
          </div>
          @if (user.auth) {
            <div class="mt-20 hidden md:block">
              <button routerLink="/deposit" class="btn btn--filled-primary">
                {{ 't.deposit' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </div>
    @if (!user.auth) {
      <div>
        <button (click)="user.authUser()" class="btn btn--filled-primary">
          {{ user.authKeyTranslate | translate }}
        </button>
      </div>
    }
  </div>
</ng-template>
